// extracted by mini-css-extract-plugin
module.exports = {"role_head":"Role_role_head__61981","role_body":"Role_role_body__HEBDi","image":"Role_image__37gRc"};